import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { LEARN } from '@/constants/testIds';
import SEO from '@/components/SEO';

const Learn = () => {
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCat, setActiveCat] = useState(null);
  useEffect(() => {
    api.get('/content/articles').then(({ data }) => setArticles(data));
    api.get('/content/article-categories').then(({ data }) => setCategories(data));
  }, []);

  const shown = activeCat ? articles.filter((a) => a.category === activeCat) : articles;

  return (
    <>
      <SEO title="Knowledge Hub" description="Foundations, doshas, daily rhythms, seasonal wellness — Ayurveda quietly explained." />
      <div className="bg-sans_bone">
        <section className="sans-section">
          <div className="sans-container">
            <div className="sans-label mb-6">Knowledge Hub</div>
            <h1 className="sans-h1">Ayurveda,<br/>quietly explained.</h1>
            <p className="sans-body mt-8 max-w-xl">Foundations, doshas, daily rhythms, seasonal wellness — no mysticism, no marketing.</p>

            {categories.length > 0 && (
              <div className="mt-12 flex flex-wrap gap-2">
                <button onClick={() => setActiveCat(null)} className={`px-4 py-2 text-xs uppercase tracking-[0.18em] border transition-colors ${!activeCat ? 'bg-sans_ink text-sans_bone border-sans_ink' : 'bg-white border-sans_line text-sans_ink hover:border-sans_ink'}`}>All</button>
                {categories.map((c) => (
                  <button key={c} onClick={() => setActiveCat(c)} className={`px-4 py-2 text-xs uppercase tracking-[0.18em] border transition-colors ${activeCat === c ? 'bg-sans_ink text-sans_bone border-sans_ink' : 'bg-white border-sans_line text-sans_ink hover:border-sans_ink'}`}>{c}</button>
                ))}
              </div>
            )}

            <div className="mt-12 grid md:grid-cols-3 gap-8 md:gap-12">
              {shown.map((a) => (
                <Link key={a.slug} to={`/learn/${a.slug}`} data-testid={LEARN.articleCard(a.slug)} className="group">
                  <div className="aspect-[4/5] bg-sans_line overflow-hidden">
                    <img src={a.cover_image} alt={a.title} className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700" loading="lazy" />
                  </div>
                  <div className="mt-6">
                    <div className="sans-label">{a.category} · {a.reading_time} min read</div>
                    <div className="font-serif text-2xl md:text-3xl text-sans_ink mt-3 leading-tight">{a.title}</div>
                    <div className="text-sans_mute mt-3 text-sm leading-relaxed">{a.excerpt}</div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Learn;
